import React from 'react';
import { dayjs } from 'shared/utils/date';
import { CheckOutlined, StopOutlined } from '@ant-design/icons';
import HasPermission from 'components/HasPermission';

import { FormattedDate, FormattedNumber, FormattedRelativeTime } from 'react-intl';
import { Link } from 'react-router-dom';
import { SUPER_USER } from 'shared/constants/permissions';
import { Tag, Tooltip } from 'antd';
import selectUnit from 'shared/utils/selectUnit';
import { durationFormat } from 'shared/utils/formatter';

export const renderCustomer = ({ id, name }) => (
  <HasPermission permission={SUPER_USER} fallback={name}>
    <Link to={`/administration/customers/${id}`}>{name}</Link>
  </HasPermission>
);

export const renderNumber = value => (
  value != null ? <FormattedNumber value={value} /> : null
);

export const renderPercent = value => (
  value != null ? <FormattedNumber value={value} style="percent" maximumFractionDigits={2} /> : null
);

export const renderBool = value => {
  if (value === true || value === 'true' || value === 1 || value === '1') {
    return <CheckOutlined />;
  }
  if (value === false || value === 'false' || value === 0 || value === '0') {
    return <StopOutlined />;
  }
  return null;
};

export const renderTruthy = value => {
  if (value) {
    return <CheckOutlined />;
  }
  return null;
};

export const renderRelativeDate = date => {
  if (date) {
    const d = dayjs(date);

    if (d.isValid()) {
      return (
        <Tooltip title={<FormattedDate value={d.toDate()} year="numeric" day="numeric" month="short" hour="numeric" minute="numeric" />}>
          <span><FormattedRelativeTime {...selectUnit(d.toDate())} /></span>
        </Tooltip>
      );
    }
  }
  return null;
};

export const renderDateTime = date => date && <FormattedDate value={date} year="numeric" day="numeric" month="short" hour="numeric" minute="numeric" />;
export const renderDate = date => date && <FormattedDate value={date} year="numeric" day="numeric" month="short" />;
export const renderTime = date => date && <FormattedDate value={date} hour="numeric" minute="numeric" second="numeric" />;

export const renderTags = arr => arr?.map(c => <Tag key={c.id}>{c.title}</Tag>);
export const renderLink = url => <a href={url} target="_blank">{url}</a>;

export const renderVersion = (version, record) => {
  let v;
  if (record.versions?.length > 1) {
    v = 'Multiple';
  }

  if (record.versions?.length === 1) {
    ([v] = record.versions);
  }

  if (version) {
    v = version;
  }

  if (!v) {
    return null;
  }

  return (
    <Tag>{v}</Tag>
  );
};

export const getRenderer = (type) => {
  switch (type) {
    case 'number':
      return renderNumber;
    case 'percent':
      return renderPercent;
    case 'bool':
    case 'boolean':
      return renderBool;
    case 'date':
      return renderDate;
    case 'time':
      return renderTime;
    case 'datetime':
      return renderDateTime;
    case 'duration':
    case 'milliseconds':
      return milliseconds => durationFormat(milliseconds);
    case 'seconds':
      return seconds => durationFormat(seconds * 1000);
    case 'relativeDate':
      return renderRelativeDate;
    case 'tags':
      return renderTags;
    case 'url':
      return renderLink;
    default:
      return null;
  }
};
